import { render, staticRenderFns } from "./s-obj-sub-input.vue?vue&type=template&id=6866619c&"
import script from "./s-obj-sub-input.vue?vue&type=script&lang=js&"
export * from "./s-obj-sub-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports